import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const ContractCreated = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> created a contract
      </Box>
    </Box>
  );
};

export default ContractCreated;
